// extracted by mini-css-extract-plugin
export var head = "header-module--head--e2181";
export var logo = "header-module--logo--4a944";
export var logoMobile = "header-module--logo-mobile--04498";
export var toggle = "header-module--toggle--2e37c";